import { Anchor } from "@mantine/core";
import { Link } from "wouter";
import {
  getLinkToVentEmailTemplates,
  getLinkToVentGuest,
  getLinkToVentGuests,
  getLinkToVentHome,
} from "../links";
import { ReactNode } from "react";

interface LinkToVentHomeProps {
  ventId: string;
  size?: string;
  children: ReactNode;
}
export const LinkAnchorToVentHome: React.FC<LinkToVentHomeProps> = (props) => {
  return (
    <Anchor
      size={props.size ?? "md"}
      component={Link}
      href={getLinkToVentHome(props.ventId)}
    >
      {props.children}
    </Anchor>
  );
};

interface LinkAnchorToVentEmailTemplatesProps {
  ventId: string;
  size?: string;
  children: ReactNode;
}
export const LinkAnchorToVentEmailTemplates = (
  props: LinkAnchorToVentEmailTemplatesProps
) => {
  return (
    <Anchor
      size={props.size ?? "md"}
      component={Link}
      href={getLinkToVentEmailTemplates(props.ventId)}
    >
      {props.children}
    </Anchor>
  );
};

interface LinkToGuestProps {
  ventId: string;
  guestId: string;
  size?: string;
  children: ReactNode;
}
export const LinkAnchorToGuest: React.FC<LinkToGuestProps> = (props) => {
  return (
    <Anchor
      size={props.size ?? "md"}
      component={Link}
      href={getLinkToVentGuest(props.ventId, props.guestId)}
    >
      {props.children}
    </Anchor>
  );
};

interface LinkToGuestsProps {
  ventId: string;
  size?: string;
  children: ReactNode;
}
export const LinkAnchorToGuests: React.FC<LinkToGuestsProps> = (props) => {
  return (
    <Anchor
      size={props.size ?? "md"}
      component={Link}
      href={getLinkToVentGuests(props.ventId)}
    >
      {props.children}
    </Anchor>
  );
};
